import React, { Children, useEffect, useRef, useState } from "react";
import Oval from "react-loading-icons/dist/esm/components/oval";
import { useDispatch, useSelector } from "react-redux";
import { ChangeoutputPinState } from "../../../../../../store/service-actions"
import Card from "../../../../Cards/Card";
import { socket } from "../../../../../../Socket/socket";
import useSocketManager from "../../../../../../Socket/useSocketManager";
import classes from "./PinOutput.module.css";
import InactiveIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/Pin/default - Off.svg";
import HiddenIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/HiddenPin.svg";
import pulseIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/Pin/__Switch - Pulse.png";
import LockIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/lock_icon.png"
import managerOnly from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/PinIcon-Manager/crown_grey.png"
import adminOnly from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/PinIcon-Manager/crown.png"
import { Dialog } from "primereact/dialog";
import { GenerateLockOTPAPI, switchLatch, AmendSchedule as AmendScheduleAPI, getSingleDeviceData, IgnoreScheduleAPI, tempScheduleAPI, deleteScheduleApi } from "../../../../../../Api Methods/Api";
import { GetSingleDeviceData } from "../../../../../../store/service-actions";
import { useGetPasscodes } from "../../../../../hooks/useGetPasscodes";
import PasscodeContentLayout from "../../../../Cards/Automations/VirutalSources/SmartLocks/PasscodeContentLayout";
import Battery from "../../../../../Battery/Battery";
import UseDateFormat from "../../../../../hooks/UseDateFormat";
import UseParseYearMonthDate from "../../../../../hooks/UseParseYearMonthDate";
import DataManager from "../../../../../../hooks/DataManager";
import Modal from "../../../../../Modal/Modal";
import GenerateLockOnTimePassCodeForm from "../../../../Cards/Automations/EditAutomations/GenerateLockOnTimePassCodeForm";
import ShowOTPPopup from "../../../../Cards/Automations/VirutalSources/SmartLocks/ShowOTPPopup";
import Lottie from 'lottie-react'
import loadingAnim from '../../../../../../assets/animations/newLoading.json'
import masterPinAnim from '../../../../../../assets/animations/masterPin.json'
import failAnim from '../../../../../../assets/animations/fail.json'
import Button1 from "../../../../Button/Button1";
import yellowWarn from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/yellow_warn.png'
import amberWarn from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/amber_warn.png'
import redWarn from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/red_warn.png'
import { Button } from "primereact/button";
import HolidayModeWarningDialog from "./HolidayModeWarningDialog";
import { AmendScheduleDialog } from "../../../../../../Pages/HolidayMode/AmendScheduleDialog";
import { TempScheduleDialog } from "../../../../../../Pages/HolidayMode/TempScheduleDialog";
import { UseConvertZonedDateTime, UseParseNaiveDateTime } from "../../../../../hooks/UseConvertZonedDateTime";

/* offline since date could be hoverable */
export const SinglePinOutput = ({ type, SmartLock, active, pinNumber, PinState, pinName, imageFromPath, otherStateImageFromPath, isManagerOnly, isAdminOnly, missedPolls, offlineSinceDate, getDeviceStatus, pinStatusOn, pinStatusOff, buttonClicked, pinStateLoading, HandlePinClick, actionOneOffLabel, actionOneOnLabel, lockBattery, LockReadDate, timeLeft, linkedIntegrationIcon, scheduleText, getPasscodes, openAmendDialog, setShowTempSch, tempScheduleText, setShowCancelTempSch, DeviceExtraDetails }) => (
    <div className={classes.pinContainer} style={{ opacity: !active && "50%",backgroundColor: SmartLock != null && "var(--PinLockColor)" }}>
        {/* top row bit */}
        <div className={classes.cardRow}>
            <div className={classes.iconGroup}>
                <img className={classes.pinIconTopLeft} style ={{ filter: pinStateLoading && 'grayscale(100%)'}} src={SmartLock == null ? (active ? PinState ? imageFromPath : otherStateImageFromPath : InactiveIcon) : LockIcon}/>
                <h3 className={classes.pinName} style={{color: SmartLock == null ? "#737373" : "#ffffff", fontWeight:"450", fontSize: '16px'}}>{pinName}</h3>
            </div>
            <div className={classes.iconGroup}>
                {isManagerOnly && <img className={classes.managerIcon} style={{ filter: SmartLock != null && "brightness(0) invert(1)" }} src={managerOnly} /> }
                {isAdminOnly && <img className={classes.icon} style={{ filter: SmartLock != null && "brightness(0) invert(0)" }} src={adminOnly} />}
                { missedPolls > 0 && SmartLock == null && (
                    <div>
                    <img
                        src={missedPolls == 1 ? yellowWarn : missedPolls == 2 ? amberWarn : missedPolls >= 3 ? redWarn : ""}
                        className={classes.icon}
                        alt="Warning"
                        title={getDeviceStatus(missedPolls)}
                    />
                    </div>
                )}
                {linkedIntegrationIcon && (
                    <img
                        src={linkedIntegrationIcon}
                        alt="Linked integration"
                        title="Linked to an integration"
                        style={{ width: "22px", height: "22px" }}
                    />
                )}
            </div>
        </div>

        {/* mid row - status */}
        <div className={classes.cardRow}>
            {SmartLock == null ? (
                <>
                    <div className={classes.iconGroup}>
                        {type !== 'pulse' ? (
                            <>
                                <div className={classes.circle} style={{ backgroundColor: !pinStateLoading ? (active ? (PinState ? 'rgb(230, 122, 129)' : 'rgb(3, 160, 92)') : 'rgb(117, 117, 117)') : 'rgb(117, 117, 117)' }} />
                                <h3 className={!pinStateLoading ? active ? (PinState ? classes.On : classes.Off) : classes.inactive : classes.loading} style={{ fontSize: '16px', fontWeight: 450, margin: 0 }}>
                                    {buttonClicked ? "Please wait..." : active ? (PinState ? pinStatusOff : pinStatusOn) : "Inactive"}
                                </h3>
                            </>
                        ) : (
                            <img style={{ height: '26px', width: '26px'}} src={pulseIcon}/>
                        )}
                    </div>
                    <div classname={classes.iconGroup}>
                        {active && type !== 'pulse' && (
                            <p className={scheduleText ? classes.scheduleText : classes.clickToText}>
                                {scheduleText || "No Schedule Today"}
                            </p>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <div className={classes.iconGroup}>
                        <Battery BatteryPowerLevel={lockBattery} isActive={active} />
                        <h3 style={{ color: '#ffffff', fontSize: '16px', fontWeight: 450, margin: 0 }}> {lockBattery + "%"}</h3>
                    </div>
                    <div classname={classes.iconGroup}>
                        {active && (
                            <p className={classes.clickToText} style={{ color: '#ffffff'}}> 
                                {LockReadDate}   
                            </p> // do logic for this and when there is a schedule
                        )}
                    </div>
                </>
            )}
        </div>

        {/* bottom row  */}
        {active && (
            <div className={classes.buttonRow}>
                {SmartLock == null ? (
                    <>
                        {type === 'pulse' ? (
                            <button className={classes.actionButton} onClick={HandlePinClick} disabled={pinStateLoading || PinState}>
                                {pinStateLoading ? (
                                    <Oval stroke="black" strokeWidth={6} width={13} height={13} />
                                ) : PinState ? (
                                    timeLeft
                                ) : (
                                    <span>{actionOneOnLabel}</span>
                                )}
                            </button>
                        ) : (
                            <> 
                                <button className={classes.actionButton} onClick={() => tempScheduleText ? setShowCancelTempSch(true) : HandlePinClick(SmartLock)}>
                                    {buttonClicked ? (
                                        <Oval stroke="black" strokeWidth={6} width={13} height={13} />
                                    ) : (
                                        PinState ? actionOneOffLabel : actionOneOnLabel
                                    )}
                                </button>
                                
                                {DeviceExtraDetails?.[pinNumber]?.tempLatchAllowed !== false && (
                                    <>
                                        <div className={classes.buttonDivider} />

                                        <button className={classes.actionButton} onClick={() => tempScheduleText ? setShowCancelTempSch(true) : setShowTempSch(true)}>
                                            {pinStateLoading ? (
                                                <Oval stroke="black" strokeWidth={6} width={13} height={13} />
                                            ) : tempScheduleText ? (
                                                tempScheduleText
                                            ) : (
                                                `Temp ${PinState ? actionOneOffLabel : actionOneOnLabel}`
                                            )}
                                        </button>
                                    </>
                                )}

                                {scheduleText && (
                                    <>
                                        <div className={classes.buttonDivider} />
                                        <button className={classes.actionButton} onClick={() => openAmendDialog()}>
                                            Amend Above
                                        </button>
                                    </>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    <>
                        <button className={classes.actionButtonLock} onClick={() => getPasscodes(SmartLock.lockID)}>
                            View Passcodes
                        </button>

                        <div className={classes.buttonDivider} />

                        <button className={classes.actionButtonLock} onClick={() => HandlePinClick(SmartLock)}>
                            Create Passcode
                        </button>
                    </>
                )}
            </div>
        )}

    </div>
)

const PasscodesDialog = ({
    showPasscodes, setShowPasscodes, passcodes,
    showMasterPin, setShowMasterPin,
    loading, setLoading,
    SmartLock,
    showCreatePasscode, setShowCreatePasscode, GenerateOTP,
    showCreatedPasscode, setShowCreatedPasscode, OTPCode,
    showError, setShowError
}) => (
    <>
        <Dialog
            header="Passcodes"
            visible={showPasscodes}
            style={{ width: "45vw" }}
            onHide={() => setShowPasscodes(false)}
        >
            <div style={{
                maxHeight: "70vh",
                overflowY: "auto",
                alignItems:"center",
                display:"flex",
                flexDirection:"column",
                padding: "10px"}}>

                <Button
                    label="Show Master PIN"
                    severity="danger"
                    onClick={()=> setShowMasterPin(true)}
                    size="large"
                    style={{ width: '100%', fontSize: '16px', padding: '16px'}}/>
                <br/>
                {passcodes.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                        <h3>No passcodes created</h3>
                    </div>
                ) : (
                    passcodes.map((passcode, index) => (
                        <div key={index} style={{ width: '100%' }}>
                            <PasscodeContentLayout passcodeData={passcode} />
                        </div>
                    ))
                )}
            </div>
        </Dialog>

        <Dialog
            header="Master Pin"
            visible={showMasterPin}
            style={{ width: "40vw" }}
            onHide={() => setShowMasterPin(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={masterPinAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff", fontWeight:600, fontSize:"25px" }}>{SmartLock?.masterPin || "N/A"}</h3>
                <br />
                <br />
                <Button label="Close" icon="pi pi-times" severity="secondary" onClick={() => setShowMasterPin(false)} />
            </div>
        </Dialog>

        <Dialog
            header="Please wait"
            visible={loading}
            style={{ width: "35vw" }}
            onHide={() => setLoading(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h3 style={{color:"#6e6e6eff"}}>Getting passcodes...</h3>
                <br></br>
                <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, downloading passcodes</p>
                <Lottie
                    animationData={loadingAnim}
                    loop={true}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />
            </div>
        </Dialog>

        <Dialog
            header="Generate Passcode"
            visible={showCreatePasscode}
            style={{ width: "30vw" }}
            onHide={() => setShowCreatePasscode(false)}
        >
            <GenerateLockOnTimePassCodeForm SmartLock={SmartLock} GenerateOTP={GenerateOTP} />
        </Dialog>

        <Dialog
            header="Lock Access Code"
            visible={showCreatedPasscode}
            style={{ width: "40vw" }}
            onHide={() => setShowCreatedPasscode(false)}
        >
            <ShowOTPPopup pincode={OTPCode} closeModal={() => setShowCreatedPasscode(false)} />
        </Dialog>

        <Dialog
            header="Error"
            visible={showError}
            style={{ width: "40vw" }}
            onHide={() => setShowError(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Failed to generate pincode</h3>
                <p style={{ textAlign: "center", color: "#6e6e6eff" }}>Please note, you can only generate up to 5 pincodes per hour</p>
                <br />
                <Button onClick={() => setShowError(false)} label="Close" severity="secondary" />
            </div>
        </Dialog>
    </>
)

const PinOutput = ({ OutPutPin, polarity, SmartLock, firmware, holidayModeActive, linkedIntegrationIcon, schedules, pinNameMap, todaysSchedules, setHasDeviceChanged, temporarySchedules, DeviceExtraDetails }) => {
    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const companyName = useSelector(state => state.auth.companyName);
    const userID = useSelector(state => state.auth.userID);

    const { pinName, pinStatusOff, pinStatusOn, pinState, icon, accessLevel, DeviceUUID, Pin, active, type, DeviceType, missedPolls } = OutPutPin;
    const actionOneOnLabel = OutPutPin.actionOneOnLabel || "disarm";
    const actionOneOffLabel = OutPutPin.actionOneOffLabel || "arm";

    {/* 
    console.log('OUTPUT PIN', OutPutPin);
    console.log('SMARTLOCK', SmartLock);
    console.log('TODAYS SCHEDULES', todaysSchedules);
    console.log('temp schedules', temporarySchedules);
    */}

    const accessLevelRef = useRef(accessLevel);
    if (accessLevel !== undefined) {
        accessLevelRef.current = accessLevel;
    }

    const missedPollsRef = useRef(missedPolls);
    if (missedPolls !== undefined) {
        missedPollsRef.current = missedPolls;
    }

    const lowerCaseStringIcon = icon?.toLowerCase();
    const image = lowerCaseStringIcon + " - Off";
    const otherStateImage = icon + " - On";
    const staticPath = "/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/";
    const isManagerOnly = accessLevelRef.current === "manager"
    const isAdminOnly = accessLevelRef.current === "admin"
    const imageFromPath = `${process.env.PUBLIC_URL}${staticPath}${image}.png`
    console.log(imageFromPath);
    let otherStateImageFromPath = `${process.env.PUBLIC_URL}${staticPath}${otherStateImage}.png`;

    console.log(imageFromPath);
    console.log(otherStateImageFromPath);

    console.log('extra details', DeviceExtraDetails);
    console.log('todays schedules', todaysSchedules);
    const apiDataRef = useRef({ token, client, companyName });
    const apiData = {
        token,
        client,
    }



    const { passcodes, loading, setLoading, showPasscodes, setShowPasscodes, getPasscodes } = useGetPasscodes(apiData, dispatch);

    const initialPinState = polarity === 1 ? pinState : !pinState;

    const [PinState, setPinState] = useState();
    const [pinStateLoading, setPinStateLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);

    const POLL_INTERVAL_MINUTES = 10;

    const offlineMs = (missedPollsRef.current || 0) * POLL_INTERVAL_MINUTES * 60 * 1000;
    const offlineSinceDate = new Date(Date.now() - offlineMs).toLocaleDateString()
    
    const [showMasterPin, setShowMasterPin] = useState(false);
    const [showCreatePasscode, setShowCreatePasscode] = useState(false);
    const [showCreatedPasscode, setShowCreatedPasscode] = useState(false);
    const [showError, setShowError] = useState(false);
    const [OTPCode, setOTPCode] = useState("");

    const [tempTriggerTime, setTempTriggerTime] = useState(null);

    const [showAmend, setShowAmend] = useState(false);
    const [amendPinNames, setAmendPinNames] = useState("");
    const [amendScheduleID, setAmendScheduleID] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showFail, setShowFail] = useState(false);

    const [successType, setSuccessType] = useState(null);

    const [showCancelTempSch, setShowCancelTempSch] = useState(false);
    const [showTempSch, setShowTempSch] = useState(false);
    const [length, setLength] = useState(null);

    const getTempEndTime = () => {
        const now = new Date();
        const addedMs = ((length?.hours || 0) * 60 + (length?.minutes || 0)) * 60000;
        return new Date(now.getTime() + addedMs);
    };

    // Mirrors the mobile app's deviceViewModel.tempScheduleEndTimes observer: resolve this pin's
    const pinTempSchedule = temporarySchedules?.data?.find(s => s.pin?.includes(String(OutPutPin.Pin)));

    const [tempScheduleText, setTempScheduleText] = useState(null);

    useEffect(() => {
        if (!pinTempSchedule?.time) {
            setTempScheduleText(null);
            return;
        }

        const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const todayInScheduleZone = new Intl.DateTimeFormat('en-CA', { timeZone: pinTempSchedule.timezone }).format(new Date());
        const naiveDateTime = `${todayInScheduleZone} ${pinTempSchedule.time}:00`;
        const localDateTime = UseConvertZonedDateTime(naiveDateTime, pinTempSchedule.timezone, browserTimeZone);
        const endTimeMs = UseParseNaiveDateTime(localDateTime).getTime();

        const remainingMs = endTimeMs - Date.now();
        if (remainingMs <= 0) {
            setTempScheduleText(null);
            return;
        }

        let timer;
        const onTick = () => {
            const millisUntilFinished = endTimeMs - Date.now();
            if (millisUntilFinished <= 0) {
                setTempScheduleText(null);
                clearInterval(timer);
                return;
            }
            const secs = Math.floor(millisUntilFinished / 1000);
            const h = Math.floor(secs / 3600);
            const m = Math.floor((secs % 3600) / 60);
            const s = secs % 60;
            setTempScheduleText(`${pinTempSchedule.action}s in ${h}h ${m}m ${s}s`);
        };

        onTick();
        timer = setInterval(onTick, 1000);

        return () => clearInterval(timer);
    }, [pinTempSchedule?.id, pinTempSchedule?.time, pinTempSchedule?.timezone]);

    const openAmendDialog = () => {
        const todayScheduleID = todaysSchedules?.[0]?.id;
        const todaySchedule = schedules?.find(s => s.id === todayScheduleID);

        if (todaySchedule && pinNameMap) {
            const pinNames = todaySchedule.pin
                .map(pinNum => pinNameMap[pinNum])
                .filter(Boolean)
                .join(', ');
            setAmendPinNames(pinNames);
            setAmendScheduleID(todaySchedule.id);
        }
        setShowAmend(true);
    };


    useEffect(() => {
        setPinStateLoading(false)
        setButtonClicked(false)
    }, [OutPutPin])

    useEffect(() => {
        //if external source updates the state, update PinState to reflect that
        setPinState(initialPinState);
    }, [initialPinState]);

    {/* 
    useEffect(() => {
        const fetchDeviceData = async () => {
            const response = await getSingleDeviceData(apiData, DeviceUUID, dispatch);
            console.log('getSingleDeviceData response:', response);
        };
        fetchDeviceData();
    }, [DeviceUUID]);
    */}

    useEffect(() => {
        setPinStateLoading(false);
        setButtonClicked(false);
    }, [pinState])

    const GenerateOTP = async (otpName, startDate, endDate, type, lockID) => {
        const body = {
            lockID: lockID,
            startDate: startDate,
            endDate: endDate,
            type: type,
            uuid: DeviceUUID,
            otpName: otpName,
        }

        const responseData = await GenerateLockOTPAPI(apiData, body, dispatch)
        if (responseData && responseData.success) {
            setShowCreatePasscode(false);
            setOTPCode(responseData.data.pin);
            setShowCreatedPasscode(true);
        } else {
            setShowCreatePasscode(false);
            setShowError(true);
        }
    }



    const [showHolidayWarning, setShowHolidayWarning] = useState(false);

    const performPinClick = async (smartLock) => {
        if (smartLock == null) {
            setPinStateLoading(true);
            setButtonClicked(true);

            let body = {};
            const firmwareMajor = firmware.split('.')[0];
            const firmwareMinor = firmware.split('.')[1];

            if (socket.connected) {
                if (firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7)) {
                    body["cmd"] = "setVirtualState"
                } else {
                    body["cmd"] = "setState"
                }

                body["allPins"] = "no";
                body["uuid"] = DeviceUUID;
                body["pin"] = Pin;
                body["state"] = !PinState; // could have a conditional here or no, i could just do this call regularly then do api call
                body["user"] = userID;
                body["eventID"] = crypto.randomUUID();
                socket.emit("routeCommand", body);
            } else {
                const response = await switchLatch(apiData, userID, Pin, !PinState, DeviceUUID, type, DeviceType, dispatch)
                if (response) {
                    setPinState(!PinState);
                    setPinStateLoading(false);
                    setButtonClicked(false);
                } else {
                    setPinState(PinState);
                    setButtonClicked(false);
                }
            }
        } else {
            setShowCreatePasscode(true);
        }
    }

    const HandlePinClick = (smartLock) => {
        if (smartLock == null && holidayModeActive) {
            setShowHolidayWarning(true);
        } else {
            performPinClick(smartLock);
        }
    }

    const HandleConfirmHolidayWarning = () => {
        setShowHolidayWarning(false);
        performPinClick(null);
    }

    let LockReadDate;
    if (SmartLock != null) {
        const batteryReadAt = SmartLock && SmartLock.batteryReadAt
        LockReadDate = UseParseYearMonthDate(batteryReadAt);
    }

    const createPasscode = () => {
    }

    const getDeviceStatus = (missedPolls) => {
        if (missedPolls === 1) return "Connectivity issue detected";
        if (missedPolls === 2) return "Frequent connection issues";
        if (missedPolls >= 3) return "Device offline or unresponsive";
        return "Device stable";
    };

    const AmendSchedule = async (scheduleID, time) => {
        if (!time || time == null) {
            setTempTriggerTime(null);
            return;
        }
        const formattedTime = time.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        const res = await AmendScheduleAPI(apiDataRef.current, {
            scheduleID: scheduleID,
            deviceUUID: DeviceUUID,
            newTime: formattedTime
        }, dispatch);

        if (res && res.msg === 'success') {
            setShowSuccess(true);
            setHasDeviceChanged(prev => prev + 1);
            setSuccessType('Amend');
        } else {
            setShowFail(true);
        }
    };

    const OverrideSchedule = async (scheduleID) => {
        const res = await IgnoreScheduleAPI(apiData, scheduleID, dispatch);

        if (res && res.success) {
            setShowSuccess(true);
            setHasDeviceChanged(prev => prev + 1);
            setSuccessType('Ignore');
        } else {
            setShowFail(true);
        }
    }

    const TempSchedule = async () => {
        const formattedTime = getTempEndTime().toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        const res = await tempScheduleAPI(apiData, {
            deviceUUID: DeviceUUID,
            pin: [OutPutPin.Pin.toString()],
            days: ["0", "1", "2", "3", "4", "5", "6"],
            time: formattedTime,
            active: 1,
            action: PinState ? actionOneOnLabel.toUpperCase() : actionOneOffLabel.toUpperCase(),
            reminder: 0,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        })

        if (res && res.success) {
            setHasDeviceChanged(prev => prev + 1);
        } else {
            setShowFail(true);
        }
    }

    const CancelTempSchedule = async () => {
        if (!pinTempSchedule?.id) {
            setShowCancelTempSch(false);
            return;
        }

        const res = await deleteScheduleApi(apiData, pinTempSchedule.id, dispatch);

        if (res && res.success) {
            HandlePinClick();
            setHasDeviceChanged(prev => prev + 1);
        } else {
            setShowFail(true);
        }
        setShowCancelTempSch(false);
    }

    const getTodayScheduleText = () => {
        if (!todaysSchedules?.length) return null;

        const todaySchedule = todaysSchedules[0];

        // for when user modifies in session (before API call completes)
        if (tempTriggerTime) {
            const formattedTime = tempTriggerTime.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
            return `${todaySchedule.action}s at ${formattedTime} (modified)`;
        }

        // otherwise depend on api
        const modifiedSuffix = todaySchedule.was_modified === 1 ? ' (modified)' : '';
        return `${todaySchedule.action}s at ${todaySchedule.nextSchedule}${modifiedSuffix}`;
    };


    return (
        <>
            <HolidayModeWarningDialog
                visible={showHolidayWarning}
                onConfirm={HandleConfirmHolidayWarning}
                onCancel={() => setShowHolidayWarning(false)}
            />

            <AmendScheduleDialog
                showAmend={showAmend} setShowAmend={setShowAmend}
                pinNames={amendPinNames}
                scheduleID={amendScheduleID}
                tempTriggerTime={tempTriggerTime} setTempTriggerTime={setTempTriggerTime}
                amendSchedule={AmendSchedule}
                showSuccess={showSuccess} setShowSuccess={setShowSuccess}
                showFail={showFail} setShowFail={setShowFail}
                successType={successType}
                OverrideSchedule={OverrideSchedule}
            />

            <TempScheduleDialog 
                showTempSch={showTempSch} setShowTempSch={setShowTempSch}
                length={length} setLength={setLength}
                PinState={PinState}
                HandlePinClick={HandlePinClick}
                TempSchedule={TempSchedule}
                showCancelTempSch={showCancelTempSch} setShowCancelTempSch={setShowCancelTempSch}
                CancelTempSchedule={CancelTempSchedule}
            />

            <PasscodesDialog
                showPasscodes={showPasscodes} setShowPasscodes={setShowPasscodes}
                passcodes={passcodes}
                showMasterPin={showMasterPin} setShowMasterPin={setShowMasterPin}
                loading={loading} setLoading={setLoading}
                SmartLock={SmartLock}
                showCreatePasscode={showCreatePasscode} setShowCreatePasscode={setShowCreatePasscode}
                GenerateOTP={GenerateOTP}
                showCreatedPasscode={showCreatedPasscode} setShowCreatedPasscode={setShowCreatedPasscode}
                OTPCode={OTPCode}
                showError={showError} setShowError={setShowError}
            />
            <SinglePinOutput
                SmartLock={SmartLock}
                active={active}
                pinNumber={Pin}
                PinState={PinState}
                pinName={pinName}
                imageFromPath={imageFromPath}
                otherStateImageFromPath={otherStateImageFromPath}
                isManagerOnly={isManagerOnly} isAdminOnly={isAdminOnly}
                missedPolls={missedPollsRef.current} offlineSinceDate={offlineSinceDate}
                getDeviceStatus={getDeviceStatus}
                pinStatusOn={pinStatusOn} pinStatusOff={pinStatusOff}
                buttonClicked={buttonClicked} pinStateLoading={pinStateLoading}
                HandlePinClick={HandlePinClick}
                actionOneOffLabel={actionOneOffLabel} actionOneOnLabel={actionOneOnLabel}
                lockBattery={SmartLock?.battery} LockReadDate={LockReadDate}
                linkedIntegrationIcon={linkedIntegrationIcon}
                scheduleText={getTodayScheduleText()}
                getPasscodes={getPasscodes}
                openAmendDialog={openAmendDialog}
                setShowTempSch={setShowTempSch}
                tempScheduleText={tempScheduleText}
                setShowCancelTempSch={setShowCancelTempSch}
                DeviceExtraDetails={DeviceExtraDetails}
            />
            {/* <button className={`${classes["pin-switch"]} ${!active && classes["disabled-hover"]}`} style={{ opacity: !active && "50%", backgroundColor: SmartLock != null && "var(--PinLockColor)" }} disabled={buttonClicked} onClick={() => HandlePinClick(SmartLock)}>

                {buttonClicked && SmartLock == null && (
                    <div className={classes.overlay} style={{ backgroundColor: "rgba(0,0,0,0.45)", pointerEvents: "none" }}>
                        <Oval stroke="white" strokeWidth={3} width={36} height={36} />
                    </div>
                )}

                <div className={classes.top}>
                    {SmartLock == null ?
                    <>
                        <h3 className={classes.pinName} style={{color:"#737373", fontWeight:"450", marginBottom:"5px"}}>{pinName}</h3>

                        <div className={classes.topRightIconGroup}>
                            {isManagerOnly && <img className={classes.imgManager} src={managerOnly} />}
                            {isAdminOnly && <img className={classes.imgManager2} src={adminOnly} />}
                            { missedPolls > 0 ?
                        <>
                        <img
                            src={missedPolls == 1 ? yellowWarn : missedPolls == 2 ? amberWarn : missedPolls >= 3 ? redWarn : ""}
                            className={classes.pinIconTopRight}
                            alt="Warning"
                            title={getDeviceStatus(missedPolls)}
                        />
                        <p className={classes.warningIconText} style={{color:"#6e6e6e", fontSize:"9px", alignContent:"flex-end", fontWeight:500}}>{offlineSinceDate}</p>
                        </>
                        :
                         <img className={classes.pinIconTopRight} src={active ? PinState ? imageFromPath : otherStateImageFromPath : InactiveIcon} />
                        }

                        </div>

                        {linkedIntegrationIcon && (
                            <img
                                src={linkedIntegrationIcon}
                                alt="Linked integration"
                                title="Linked to an integration"
                                style={{ position: "absolute", top: "40px", right: "8px", width: "22px", height: "22px", objectFit: "contain" }}
                            />
                        )}
                    </>
                        :
                        <>
                            <h3 className={classes.pinName} style={{color:"#ffffff", fontWeight:"450", marginBottom:"5px"}}>{pinName}</h3>
                            <div className={classes.topRightIconGroup}>
                                {isManagerOnly && <img className={classes.imgManager} style={{filter: "brightness(0) invert(1)"}} src={managerOnly} />}
                                {isAdminOnly && <img className={classes.imgManager2} style={{filter: "brightness(0) invert(0)"}} src={adminOnly} />}

                                <img className={classes.pinIconTopRight} src={LockIcon} />
                            </div>
                        </>
                    }

                    {SmartLock == null ?
                    <>
                        <h3 className={!pinStateLoading ? active ? PinState ? classes.On : classes.Off : classes.inactive : classes.loading}>
                            {buttonClicked ? "Please wait..." : active ? PinState ? pinStatusOff : pinStatusOn : "Inactive"}
                        </h3>
                        {!buttonClicked && active && (
                            <p className={classes.clickToText}>
                                Click to {PinState ? actionOneOffLabel : actionOneOnLabel}
                            </p>
                        )}
                    </>
                    :
                    <>
                        <div className={classes.lockBatteryRow}>
                            <Battery BatteryPowerLevel={SmartLock.battery} isActive={active} />
                            <h2 className={classes["battery-percentage"]}>{SmartLock.battery + "%"}</h2>
                            <h2 className={classes.lockDate}>{LockReadDate}</h2>
                        </div>
                        <p className={classes.clickToText} style={{color: "#ffffff"}}>Click to generate passcode</p>
                    </>
                    }
                </div>

                <div className={classes.bottom} />
            </button> */}
        </>
    );
}

export default PinOutput;